import { Injectable } from '@angular/core';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ActionEnum } from '../../../enum/action.enum';
import { ActionService } from './action.service';
import { ShipmentQuoting } from '../../../models/shipment-quoting';
import { ActionStatusEnum } from '../../../enum/action-status.enum';
import { ServerMessage } from '../../../models/server-message';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class QuotingService {

    constructor(private store: Store<AppState>, private actionService: ActionService, private snackbar: MatSnackBar) {}

    private extractMessages(id: string, action: any): ServerMessage[] {
        const quoteMessages = action.output && action.output[id] ? action.output[id].messages : [];
        return action.errors ? action.errors.concat(quoteMessages) : quoteMessages;
    }

    quoteShipmentSync(id: string): Observable<ShipmentQuoting> {
        return this.actionService.sync(ActionEnum.QUOTE_SHIPMENT, [ id ]).pipe(
            filter((action) => action.status === ActionStatusEnum.COMPLETED || action.status === ActionStatusEnum.ERROR),
            map((action) => ({
                shipmentId: id,
                progress: action.progress,
                busy: action.status === ActionStatusEnum.PROCESSING,
                quotes: action.output && action.output[id] && action.output[id].quotes ? action.output[id].quotes : [],
                messages: this.extractMessages(id, action),
                queued: false,
                completed: true,
                preSelectedId: action.output && action.output[id] ? action.output[id].preSelectedId : null
            }))
/*
            startWith({
                progress: 0,
                status: ActionStatusEnum.PROCESSING,
                output: {},
                errors: []
            }),
            tap((action) => {
                console.log(action);
                if (action.errors) {
                    for (const error of action.errors) {
                        this.snackbar.open(error);
                    }
                }
            }),
            map((action) => ({
                shipmentId: id,
                progress: action.progress,
                busy: action.status === ActionStatusEnum.PROCESSING,
                quotes: action.output && action.output[id] && action.output[id].quotes ? action.output[id].quotes : [],
                messages: this.extractMessages(id, action),
                queued: false
            }))
*/
        );
    }

    quoteShipmentMulti(ids: string[]): Observable<ShipmentQuoting[]> {
        return this.actionService.async(ActionEnum.QUOTE_MULTI_SHIPMENT, ids).pipe(
            filter((action) => action.status === ActionStatusEnum.COMPLETED || action.status === ActionStatusEnum.ERROR),
            map(action => {
                return ids.map(id => ({
                    shipmentId: id,
                    quotes: action.output && action.output[id] ? action.output[id].quotes : [],
                    messages: this.extractMessages(id, action),
                    busy: false,
                    progress: 100,
                    queued: false,
                    completed: true,
                    preSelectedId: action.output && action.output[id] ? action.output[id].preSelectedId : null
                }));
            })
        );
    }

}
